/**
 * Each one of our applications runs in different flavors.
 * An application combined with an enviroment determine its unique flavor.
 * The flavor can then be used to determine configuration and behavior of the application.
 *
 * E.g., api-server-staging is the api-server application running in the staging environment.
 *
 * Flavors are standard across the entire monorepo.
 * They also dictate relevant naming conventions, e.g., always use 'prod' not 'production'.
 */
export const Flavors = {
  LOCAL: 'local',
  STAGING: 'staging',
  PROD: 'prod',
} as const;

/** Type representing valid flavor values. */
export type Flavor = (typeof Flavors)[keyof typeof Flavors];
